import React, { Component } from "react";
import PropTypes from "prop-types";
//Limitless imports
import { isMessageEditorState } from "../../..";
import { MessageEditor } from "../../..";
import ReadOnlyFooter from "../read-only-footer/ReadOnlyFooter";
import ConversationEndedAnchor from "./ConversationEndedAnchor";
class ConversationFooter extends Component {
  shouldComponentUpdate(nextProps) {
    return !nextProps.isParentLoading;
  }
  render() {
    const {
      message
    } = this.props;
    const isEditorMode = isMessageEditorState(message.conversationState.state);
    if (isEditorMode) {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ConversationEndedAnchor, {
        message: message
      }), /*#__PURE__*/React.createElement(MessageEditor, this.props));
    }
    return /*#__PURE__*/React.createElement(ReadOnlyFooter, this.props);
  }
}
export default ConversationFooter;
ConversationFooter.propTypes = {
  message: PropTypes.object.isRequired,
  isParentLoading: PropTypes.bool.isRequired
};